module.exports = __webpack_public_path__ + "static/media/michalz.ae090fc6.jpg";